import React from "react";
import "./style.css";

export default function Box(props) {
  const { data } = props;

  return (
    <div className="box_container">
        {
            data.map((val)=>{
                return (
                    <div className="card">
                        <h4>{val.label}</h4>
                        <div className="count_value"  style={{backgroundColor:'#'+props.custom_design.colors[1].color}}>
                            <h4 style={{color:'#'+props.custom_design.colors[7].color}}>{val.count}</h4>
                        </div>
                    </div>
                )
            })
        }
      
    </div>
  );
}
